import * as React from 'react';
import { openZoomed } from '../../../actions/SpendingReportActions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ReactTooltip from 'react-tooltip';

interface zoom_help {
    openZoomed?(number);
    className?: string;
    chart_no: number;
}

class ZoomHelp extends React.Component<zoom_help, {}> {
    constructor(props) {
        super(props);
        this.handleOpenClick = this.handleOpenClick.bind(this);
        this.handleTabKeyUp = this.handleTabKeyUp.bind(this);
    }


    handleOpenClick(chart_no) {
        this.props.openZoomed(chart_no);
    }

    handleTabKeyUp(event, chart_no) {
        if(event.key == "Enter")
            this.props.openZoomed(chart_no);
    }

    render() {

        let tooltipTitle, tooltipContent;
        switch (this.props.chart_no) {
            case 1:
            case 7:
                tooltipTitle = "Interactive Employment by Occupation Chart";
                tooltipContent = "To use this chart, click on any bar that you would like to explore. <br/>Clicking on the bar will display the top ten job titles in that occupational category.<br/> To return to the main chart, click on the refresh button.";
                break;
            case 2:
            case 8:
                tooltipTitle = "Interactive Employment by Awarding Agency";
                tooltipContent = "To use the interactive features of this chart you can single-click on an<br/> occupational classification key in the legend to see the bars reordered allowing you to make better <br/>comparisons across all the agencies. The agency list is the top eight funding agencies.";
                break;
            case 3:
            case 9:
                tooltipTitle = "Interactive Vendor Spending Map";
                tooltipContent = "Move your mouse over any county to see the total dollar amount spent <br/>in that county and the top two vendors. You can use your mouse wheel to<br/> zoom in or out, and click and drag to move to different areas of the map.";
            case 4:
                tooltipTitle = "Interactive Vendor Spending Map";
                tooltipContent = "Move your mouse over any county to see the total dollar amount spent <br/>in that county and the top two vendors. You can use your mouse wheel to<br/> zoom in or out, or click and drag to move to different areas of the map."
                break;
            case 5:
                tooltipTitle = "Interactive Vendor Spending Map";
                tooltipContent = " Move your mouse over any congressional district to see the total <br/>dollar amount spent in that district. You can use your mouse wheel to<br/> zoom in or out, and click and drag to move to different areas of the map.";
                break;
            case 6:
                tooltipTitle = "Interactive Vendor Spending Map";
                tooltipContent = "Move your mouse over any congressional district to see the total dollar amount<br/> spent in that district and the top two vendors. You can use your mouse wheel to<br/> zoom in or out, and click and drag to move to different areas of the map.";
                break;
        }

        return <div className={this.props.className}>
            {!this.props.className.includes("zoomed") &&
                <span tabIndex={1} className='zoom' title="Zoom Map" onKeyUp={(e) => this.handleTabKeyUp(e,this.props.chart_no)} onClick={() => this.handleOpenClick(this.props.chart_no)}><i className="fa fa-search-plus fa-lg zoomhelp-icon"></i>Zoom</span>
            }
            <span tabIndex={1} data-tip={tooltipContent}><span className='help'><i className="fa fa-info-circle fa-lg zoomhelp-icon"></i>Info</span></span>
            <ReactTooltip multiline={true} />
            {/*
            <OverlayTrigger placement="bottom" overlay={this.getTooltip()}>
                <span className='help'><i className="fa fa-info-circle fa-lg zoomhelp-icon"></i>Info</span>
            </OverlayTrigger>*/}

        </div>
    }
}


function matchDispatchToProps(dispatch) {
    return bindActionCreators(
        { openZoomed: openZoomed }, dispatch
    )
}

export default connect(
    null,
    matchDispatchToProps
)(ZoomHelp);